var React = require('react');

function GiftCard (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-credit-card","d":"M0,15c0,1,0.8,1.8,1.8,1.8h18c1,0,1.8-0.8,1.8-1.8V8.4H0V15z M7.2,12.5\n\tc0-0.2,0.2-0.5,0.5-0.5h5.1c0.2,0,0.5,0.2,0.5,0.5V14c0,0.2-0.2,0.5-0.5,0.5H7.7c-0.2,0-0.5-0.2-0.5-0.5L7.2,12.5z M2.4,12.5\n\tc0-0.2,0.2-0.5,0.5-0.5h2.7C5.8,12,6,12.2,6,12.5V14c0,0.2-0.2,0.5-0.5,0.5H2.9c-0.2,0-0.5-0.2-0.5-0.5V12.5z M21.6,1.8v1.8H0V1.8\n\tC0,0.8,0.8,0,1.8,0l0,0h18C20.8,0,21.6,0.8,21.6,1.8C21.6,1.8,21.6,1.8,21.6,1.8z"}));
}

GiftCard.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 21.6 16.8","style":{"enableBackground":"new 0 0 21.6 16.8"},"xmlSpace":"preserve"};

module.exports = GiftCard;

GiftCard.default = GiftCard;
